import OTPInput from "otp-input-react";
import React, { useState, useEffect } from "react";
import Loader from "../../../components/loader/loader";

import Snackbar from "../../../components/snackbar/snackbar";
import { verifyOtp, userLogin, selectApplicationContext } from "../login/auth.api";
import jwtDecode from "jwt-decode";
import "./otp.css";

export default function Otp(props) {
  useEffect(() => {
    if (!props.phone) {
      props.history.push("/login");
    }
  }, []);

  const [OTP, setOTP] = useState("");
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showSelection, setShowSelection] = useState(false);
  const [records, setRecords] = useState([]);
  const [tempToken, setTempToken] = useState("");

  const activelocation = sessionStorage.getItem("next_path");
  const activePath = activelocation ?? "/dashboard";

  const completeLogin = (token) => {
    sessionStorage.setItem("token", token);
    props.login(token);

    let targetPath = activePath;
    try {
      const userData = jwtDecode(token);
      const userType = Number(userData?.user_type || userData?.user?.user_type || userData?.sub);
      const dashboardRoles = [0, 4, 5, 6, 8, 9, 10, 24];
      const publicRoles = [21, 27];

      if (dashboardRoles.includes(userType)) {
        targetPath = "/dashboard";
      } else if (publicRoles.includes(userType)) {
        targetPath = "/";
      }
    } catch (e) {
      console.error("Token decoding error:", e);
    }

    props.history.push(targetPath);
    sessionStorage.removeItem("next_path");
  };

  const manageLogin = (e) => {
    e.preventDefault();
    setSubmit(true);

    let data = {
      mobile_number: props.phone,
      otp_value: OTP,
    };
    setIsActive(true);
    verifyOtp(data)
      .then((res) => {
        if (res.multiple_records_exist) {
          setRecords(res.records || []);
          setTempToken(res.temp_token);
          setShowSelection(true);
          setIsActive(false);
          setSubmit(false);
        } else {
          completeLogin(res.token);
        }
      })
      .catch((err) => {
        setSubmit(false);
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Verification failed");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const handleSelectApplication = (record) => {
    setIsActive(true);
    const data = {
      application_id: record.type === "application" ? record.id : null,
      company_id: record.type === "company" ? record.id : null,
    };

    selectApplicationContext(data, tempToken)
      .then((res) => {
        if (res.success) {
          if (res.context) {
            localStorage.setItem("context", JSON.stringify(res.context));
          }
          completeLogin(res.token);
        } else {
          setIsActive(false);
          setSnackMessage(res.message || "Failed to select application");
          setIsSnackError(true);
          setSnackOpen(true);
        }
      })
      .catch((err) => {
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Selection error");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const resend = (e) => {
    e.preventDefault();
    let loginParam = { mobile_number: props.phone };
    setSubmit(true);
    setIsActive(true);

    userLogin(loginParam)
      .then((res) => {
        setSnackMessage(res.message);
        setSubmit(false);
        setIsActive(false);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((err) => {
        setSubmit(false);
        setSnackMessage(err.response?.data?.message || "Failed to resend OTP");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      setOTP("");
    }
  };

  const getStatusLabel = (status) => {
    const labels = {
      0: "Draft",
      1: "Submitted",
      2: "Under Review",
      3: "Approved",
      4: "Rejected",
      7: "In Progress",
    };
    return labels[status] || "Unknown";
  };

  return (
    <div className="otp-login-container">
      <Loader open={isActive} />
      <div className={`otp-login-section ${showSelection ? "selection-active" : ""}`}>
        {!showSelection ? (
          <div>
            <form onSubmit={manageLogin}>
              <div className="otp-login-body d-flex justify-content-center align-items-center flex-column">
                <div>
                  <img src="/resources/img/login/login-avatar.png" alt="" />
                </div>
                <div className="otp-number-label">Enter the OTP received in your Number</div>
                <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false} />
              </div>
              <div className="otp-login-action">
                <button disabled={submit || OTP.length < 6} className="otp-login-button">
                  Verify
                </button>
              </div>
            </form>
            <div className="d-flex justify-content-around">
              <div className="otp-not-text" onClick={() => props.history.push("/login")}>
                Re-enter your number
              </div>
              <div className="otp-resend-text" onClick={(e) => resend(e)}>
                Resend OTP
              </div>
            </div>
          </div>
        ) : (
          <div className="selection-body">
            <div className="selection-header">
              <h2>Select Your Application</h2>
              <p>You have multiple records. Please select one to continue.</p>
            </div>
            <div className="records-list">
              {records.map((record, index) => (
                <div key={index} className="record-card" onClick={() => handleSelectApplication(record)}>
                  <div className="record-main">
                    <div className="record-title">{record.company_name}</div>
                    <div className="record-ref">{record.unique_application_ref_no || `ID: ${record.id}`}</div>
                  </div>
                  <div className="record-meta">
                    {/* <span className={`status-badge status-${record.application_status}`}>
                      {getStatusLabel(record.application_status)}
                    </span> */}
                    <div className="record-type">{record.type}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="selection-footer">
              <button className="btn-back" onClick={() => setShowSelection(false)}>
                Go Back
              </button>
            </div>
          </div>
        )}
      </div>
      <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />
    </div>
  );
}
